import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=1cb1f1cc"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb1f1cc')) {
      api.createRecord('1cb1f1cc', component.options)
    } else {
      api.reload('1cb1f1cc', component.options)
    }
    module.hot.accept("./InfoIcon.vue?vue&type=template&id=1cb1f1cc", function () {
      api.rerender('1cb1f1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/InfoIcon.vue"
export default component.exports